import djangoFetch from '../../fetch/djangoFetch';

export const RESPONSE_HTML = 'RESPONSE_HTML';
export const RESPONSE_JSON = 'RESPONSE_JSON';
export const RESPONSE_JSON_WITH_HTML = 'RESPONSE_JSON_WITH_HTML';

/*
    requestData = {url: string, data: Object, method: "POST" or "GET"}
    responseObjectProperties = undefined or {
        html: string - response object property which contains modal html
        data: string - response object property which contains modal json data
    }
*/

/* eslint-disable no-undef */
class ContentProviderAjaxJQuery {
  constructor(
    requestData,
    responseType,
    responseObjectProperties = { html: 'html', data: null },
  ) {
    this.requestData = requestData;
    if (requestData.data === undefined) this.requestData.data = {};
    if (requestData.method === undefined) this.requestData.method = 'GET';
    this.responseType = responseType;
    this.responseObjectProperties = responseObjectProperties;
  }

  getContent() {
    return new Promise((resolve, reject) => {
      $.ajax(this.requestData.url, {
        data: this.requestData.data,
        success: function(responseObj) {
          switch (this.responseType) {
            case RESPONSE_HTML: {
              resolve({
                html: responseObj,
                data: null,
              });
              break;
            }
            case RESPONSE_JSON: {
              resolve({
                html: null,
                data: responseObj,
              });
              break;
            }
            case RESPONSE_JSON_WITH_HTML: {
              if (this.responseObjectProperties.data === null) {
                resolve({
                  html: responseObj[this.responseObjectProperties.html],
                  data: responseObj,
                });
              } else {
                resolve({
                  html: responseObj[this.responseObjectProperties.html],
                  data: responseObj[this.responseObjectProperties.data],
                });
              }
              break;
            }
            default: {
              resolve({
                html: null,
                data: null,
              });
            }
          }
        }.bind(this),
        error: (jqXHR, textStatus, errorThrown) => {
          reject(new Error(errorThrown));
        },
        dataType: this.responseType === RESPONSE_HTML ? 'html' : 'json',
        method: this.requestData.method,
      });
    });
  }
}

class ContentProviderAjaxDjangoFetch {
  constructor(
    input,
    init = { method: 'GET' },
    responseType,
    responseObjectProperties = { html: 'html', data: null },
  ) {
    this.input = input;
    this.init = init;
    this.responseType = responseType;
    this.responseObjectProperties = responseObjectProperties;
  }

  getContent() {
    return djangoFetch(this.input, this.init)
      .then(response => {
        if (response.headers.get('Content-Type') === 'application/json') {
          return response.json();
        } else if (response.headers.get('Content-Type') === 'text/html')
          return response.text();
      })
      .then(content => {
        switch (this.responseType) {
          case RESPONSE_HTML: {
            return Promise.resolve({
              html: content,
              data: null,
            });
          }
          case RESPONSE_JSON: {
            return Promise.resolve({
              html: null,
              data: content,
            });
          }
          case RESPONSE_JSON_WITH_HTML: {
            if (this.responseObjectProperties.data === null) {
              return Promise.resolve({
                html: content[this.responseObjectProperties.html],
                data: content,
              });
            }
            return Promise.resolve({
              html: content[this.responseObjectProperties.html],
              data: content[this.responseObjectProperties.data],
            });
          }
          default: {
            return Promise.resolve({
              html: null,
              data: null,
            });
          }
        }
      })
      .catch(error =>
        Promise.resolve({
          html: error.message,
          data: null,
        }),
      );
  }
}

export { ContentProviderAjaxJQuery, ContentProviderAjaxDjangoFetch };



// WEBPACK FOOTER //
// ./src/js/lib/modals/content_providers/ContentProviderAjax.js